import moment, { Moment } from "moment";
import { IAssignment } from "@miplatform/types";
import { addToDate, getDate } from "@miplatform/utils";
import { ASSIGNMENTS_ALL_OPTION } from "./AssignmentsCalendar.constants";

export const countAssignments = (
  assignments: IAssignment[],
  templateId: string
) => {
  if (templateId === ASSIGNMENTS_ALL_OPTION) {
    return assignments.length;
  }

  return assignments.filter(
    ({ assignmentTemplateId }) => assignmentTemplateId === templateId
  ).length;
};

export const calculateAssignmentsAutoPublishRemainingTime = (
  targetTime: Moment
): string => {
  const now = getDate();
  const diffInSeconds = targetTime.diff(now, "seconds");

  if (diffInSeconds <= 0) {
    return "00:00:00";
  }

  const duration = moment.duration(diffInSeconds, "seconds");
  const hours = String(Math.floor(duration.asHours())).padStart(2, "0");
  const minutes = String(duration.minutes()).padStart(2, "0");
  const seconds = String(duration.seconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

export const getAssignmentsCalendarDefaultDate = () => {
  const tomorrow = addToDate(new Date(), 1);

  if (tomorrow.day() === 0) {
    return addToDate(tomorrow, 1);
  }

  return tomorrow;
};
